import type { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';

import { orgPresentListingTypes } from './orgPresentListingTypes';

export function orgHasListings(org: ApiOrg) {
  return orgPresentListingTypes(org).length > 0;
}
